module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-ja.980e559f27b085429592.svg";